import { useToast } from '@chakra-ui/react'
import { FileGenerator } from 'components/molecules/FileGenerator'
import { useInstitutionsContext } from 'contexts/institutions'
import { ExportContractsParams } from 'pages/Contracts/interfaces'
import { DocumentTypes } from 'pages/Contracts/types'
import { useState } from 'react'
import ContractService from 'services/contracts'
import { generateFile } from 'utils/blob'
import formatter from 'utils/formatter'
import { removeEmptyValues } from 'utils/removeEmptyValues'
import { FilterContracts } from '../Filter/interfaces'

interface Props {
    filters: FilterContracts
    pagination: {
        limit: number
        page: number
    }
}

export const GeneratorFiles: React.FC<Props> = ({ filters, pagination }) => {
    const [loadingFile, setLoadingFile] = useState<boolean>(false)
    const toast = useToast()
    const callAPI = (type: DocumentTypes) => {
        downloadFiles(type)
    }
    const { currentInstitution } = useInstitutionsContext()

    const buildPayload = (type: DocumentTypes): ExportContractsParams => {
        return removeEmptyValues({
            ...filters,
            instituicao: currentInstitution?.id || '',
            pagina: pagination.page,
            limite: pagination.limit,
            dataFim: filters?.dataFim
                ? formatter.formatDateToPayload(filters?.dataFim)
                : '',
            dataInicio: filters?.dataInicio
                ? formatter.formatDateToPayload(filters?.dataInicio)
                : '',
            tipo: type
        })
    }

    const downloadFiles = async (type: DocumentTypes) => {
        try {
            setLoadingFile(true)

            const payload = buildPayload(type)
            const response = await ContractService.exportContracts(payload)

            generateFile(type, response)

            toast({
                title: 'Arquivo gerado com sucesso!',
                description: `O arquivo ${type} foi gerado conforme os filtros selecionados. Verifique sua pasta de downloads para acessá-lo.`,
                position: 'bottom-left',
                status: 'success',
                isClosable: true
            })
        } catch (error) {
            toast({
                title: 'Sentimos muito!',
                description: 'Ocorreu um erro, tente novamente mais tarde.',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            setLoadingFile(false)
        }
    }

    return <FileGenerator callAPI={callAPI} loading={loadingFile} />
}
